import { Component, h, Prop, Event, EventEmitter } from "@stencil/core"

@Component({
  tag: "chatbot-welcome",
  styleUrl: "bot-welcome.css",
  shadow: true,
})
export class ChatbotWelcome {
  private cdnPath: string = "https://cdn.ai12z.net/assets/bot"
  @Prop() buttonsList = []
  @Prop() welcomeMessage: string = "Hi, how can I help you?"
  @Prop() welcomelogo: string = this.cdnPath + `/v1/ai12z-bot/img/headset.png`
  @Event() buttonClick: EventEmitter
  handleButtonClick(btn: any) {
    // console.log(`Button clicked: ${btn.label}`)
    this.buttonClick.emit(btn)
    // Handle different actions based on the button clicked
  }

  render() {
    return (
      <div class="welcome-screen">
        <img src={this.welcomelogo ?? this.cdnPath + `/v1/ai12z-bot/img/headset.png`} alt="Avatar" height="64" />
        <p innerHTML={this.welcomeMessage}></p>
        <div class="button-container">{this.buttonsList?.map(button => <button onClick={() => this.handleButtonClick(button)}>{button.label}</button>)}</div>
      </div>
    )
  }
}
